<template>
  <div class="ns_container">
    <div class="header_section">
      <BaseTitle v-text="$t('notification_in_app.title')" />
      <v-btn-toggle
        :value="allNotificationsEnabled"
        small
        class="btn_toggle"
        :mandatory="allNotificationsEnabled != undefined"
        @change="handleAllNotificationChange($event)"
      >
        <v-btn small :value="true">
          <span
            class="btn_label"
            v-text="$t('notification_in_app.enable_all_notifications')"
          />
          <v-icon class="btn_icon" right>$mdiBellOutline</v-icon>
        </v-btn>
        <v-btn small :value="false">
          <span
            class="btn_label"
            v-text="$t('notification_in_app.disable_all_notifications')"
          />
          <v-icon class="btn_icon" right>$mdiBellOffOutline</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>
    <div class="body_section">
      <v-checkbox
        v-model="notificationsInApp.notifSummaryByEmail"
        :disabled="loading || updatingNotifSummaryByEmail"
        class="email_section"
        @change="updateNotifSummaryByEmail()"
      >
        <template #label>
          <div
            class="check_label"
            v-text="$t('notification_in_app.email_config_label')"
          />
        </template>
      </v-checkbox>
      <v-checkbox
        v-model="notificationsInApp.instantEmailNotification"
        :disabled="loading || updatingInstantEmailNotification"
        class="email_section"
        @change="updateInstantEmailNotification()"
      >
        <template #label>
          <div
            class="check_label"
            v-text="$t('notification_in_app.receive_by_email_label')"
          />
        </template>
      </v-checkbox>
      <div class="sub_title" v-text="$t('utils.preferences')" />
      <div class="notifications">
        <div
          v-for="(notification, i) in notifications"
          :key="`n${i}`"
          class="notification_item"
        >
          <div class="icon">
            <BaseIcon :icon="notification.icon" color="grey" />
          </div>
          <div class="noitification_label" v-text="notification.label" />
          <div class="natification_status">
            <v-progress-circular
              v-if="loading"
              :width="2"
              size="20"
              indeterminate
              color="primary"
            />
            <v-btn-toggle
              v-else
              v-model="notification.enabled"
              small
              class="btn_toggle"
              mandatory
              @change="updateNotificationStatus([notification])"
            >
              <v-btn small :value="true">
                <span class="btn_label" v-text="$t('utils.enabled')" />
                <v-icon class="btn_icon" right>$mdiBellOutline</v-icon>
              </v-btn>

              <v-btn small :value="false">
                <span class="btn_label" v-text="$t('utils.disabled')" />
                <v-icon class="btn_icon" right>$mdiBellOffOutline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardAPI from "@/modules/Authentication/Services/dashboard.api";
export default {
  name: "NotificationSetting",
  data() {
    return {
      loading: true,
      updatingNotifSummaryByEmail: false,
      updatingInstantEmailNotification: false,
      notifications: [
        {
          type: "FOLDER_ASSIGNED",
          key: "notifFolderAssignedEnabled",
          original_key: "notif_folder_assigned_enabled",
          label: this.$t("notification_in_app.folder_assigned"),
          icon: "$mdiAccountPlus",
          enabled: false,
        },
        {
          type: "UNASSIGN_COLLABORATOR",
          key: "notifUnassignCollaboratorEnabled",
          original_key: "notif_unassign_collaborator_enabled",
          label: this.$t("notification_in_app.folder_unassigned"),
          icon: "$mdiAccountMinus",
          enabled: false,
        },
        {
          type: "COURSE_ANSWERED",
          key: "notifCourseAnsweredEnabled",
          original_key: "notif_course_answered_enabled",
          label: this.$t("notification_in_app.course_answered"),
          icon: "$textBoxEdit",
          enabled: false,
        },
        {
          type: "FORM_ANSWERED",
          key: "notifFormAnsweredEnabled",
          original_key: "notif_form_answered_enabled",
          label: this.$t("notification_in_app.cosmoform_answered"),
          icon: "$textBoxEdit",
          enabled: false,
        },
        {
          type: "STATUS_CHANGED",
          key: "notifStatusChangedEnabled",
          original_key: "notif_status_changed_enabled",
          label: this.$t("notification_in_app.status_changed"),
          icon: "$folderArrowLeftRight",
          enabled: false,
        },
        {
          type: "OFFER_CONSULTED",
          key: "notifOfferConsultedEnabled",
          original_key: "notif_offer_consulted_enabled",
          label: this.$t("notification_in_app.offer_consulted"),
          icon: "$mdiFileEyeOutline",
          enabled: false,
        },
        {
          type: "OFFER_VALIDATED",
          key: "notifOfferValidatedEnabled",
          original_key: "notif_offer_validated_enabled",
          label: this.$t("notification_in_app.offer_validated"),
          icon: "$fileCheck",
          enabled: false,
        },
        {
          type: "OFFER_REJECTED",
          key: "notifOfferRejectedEnabled",
          original_key: "notif_offer_rejected_enabled",
          label: this.$t("notification_in_app.offer_rejected"),
          icon: "$fileRejected",
          enabled: false,
        },

        {
          type: "OFFER_SIGNED",
          key: "notifOfferSignedEnabled",
          original_key: "notif_offer_signed_enabled",
          label: this.$t("notification_in_app.offer_signed"),
          icon: "$fileSign",
          enabled: false,
        },
        {
          type: "MEMBER_SIGNED",
          key: "notifMemberSignedEnabled",
          original_key: "notif_member_signed_enabled",
          label: this.$t("notification_in_app.member_signed"),
          icon: "$mdiDraw",
          enabled: false,
        },
        {
          type: "MEMBER_COMMENT_ADDED",
          key: "notifCommentAddedEnabled",
          original_key: "notif_comment_added_enabled",
          label: this.$t("notification_in_app.member_comment_added"),
          icon: "$mdiCommentMultiple",
          enabled: false,
        },
        {
          type: "FOLDER_ARCHIVED",
          key: "notifFolderArchivedEnabled",
          original_key: "notif_folder_archived_enabled",
          label: this.$t("notification_in_app.folder_archived"),
          icon: "$mdiArchive",
          enabled: false,
        },
      ],
      notificationsInApp: {},
    };
  },
  computed: {
    allNotificationsEnabled() {
      if (this.notifications.every((n) => n.enabled)) return true;
      if (this.notifications.every((n) => !n.enabled)) return false;
      return null;
    },
  },
  created() {
    this.fetchNotificationsInApp();
  },
  methods: {
    async fetchNotificationsInApp() {
      this.loading = true;
      try {
        const res = await DashboardAPI.getNotificationsInApp();
        this.notificationsInApp = res.data;
        this.notifications.forEach((n) => {
          n.enabled = !!this.notificationsInApp[n.key];
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.loading = false;
    },
    async updateNotificationStatus(notifications) {
      try {
        const payload = {};
        for (const notif of notifications) {
          payload[notif.original_key] = notif.enabled;
        }
        await DashboardAPI.patchNotificationsInApp({
          payload,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("notification_in_app.update_success"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
    },
    async handleAllNotificationChange(enabled) {
      if (enabled == undefined) return;
      const payload = {};
      for (const notif of this.notifications) {
        notif.enabled = enabled;
        payload[notif.original_key] = enabled;
      }
      try {
        await DashboardAPI.patchNotificationsInApp({
          payload,
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("notification_in_app.update_success"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
    },
    async updateNotifSummaryByEmail() {
      this.updatingNotifSummaryByEmail = true;
      try {
        await DashboardAPI.patchNotificationsInApp({
          payload: {
            notif_summary_by_email: this.notificationsInApp.notifSummaryByEmail,
          },
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("notification_in_app.update_success"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.updatingNotifSummaryByEmail = false;
    },
    async updateInstantEmailNotification() {
      this.updatingInstantEmailNotification = true;
      try {
        await DashboardAPI.patchNotificationsInApp({
          payload: {
            instant_email_notification:
              this.notificationsInApp.instantEmailNotification,
          },
        });
        this.$store.dispatch("snackbar/active", {
          message: this.$t("notification_in_app.update_success"),
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.updatingInstantEmailNotification = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ns_container {
  background: #fff;
  margin-bottom: 24px;
  padding: 24px;
  .header_section {
    display: flex;
    justify-content: space-between;
  }
  .body_section {
    padding-top: 24px;
    .email_section {
      margin: 0;
      .check_label {
        color: #707080;
        font-size: 14px;
      }
    }
    .sub_title {
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 16px;
    }
    .notifications {
      display: flex;
      flex-direction: column;
      gap: 16px;
      .notification_item {
        display: flex;
        align-items: center;
        padding: 16px;
        border-radius: 5px;
        background: #e6eff4;
        gap: 16px;
        .icon {
          width: 32px;
          height: 32px;
          border-radius: 5px;
          background: #f5f5f5;
          display: flex;
          justify-content: center;
          align-items: center;
          ::v-deep {
            .v-icon {
              width: 20px;
              height: 20px;
            }
          }
        }
        .noitification_label {
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          flex: 1;
        }
      }
    }
  }
  .btn_toggle {
    .btn_label {
      font-family: Inter;
      font-size: 12px;
      color: #333333;
    }
    .btn_icon {
      color: #333333;
      ::v-deep {
        .v-icon {
          width: 14px;
          height: 14px;
          color: #333333;
        }
      }
    }
  }
}
</style>
